import axios from "axios";
import store from '@/store'

axios.defaults.headers = {}

const service = axios.create({
    baseURL:'',
    timeout: 86400000,
    headers: {}
    // headers: {
    //     // 'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
    //     'content-type': "application/json;charset=UTF-8"
    // }
});


service.interceptors.request.use(
    config => {
        if (!config.stopLoading) {
            store.dispatch('loading/setLoadingSpin', true)
        }
        return config;
    },
    error => {
        store.dispatch('loading/setLoadingSpin', false)
        console.log(error); // for debug
        return Promise.reject(error);
    }
);


service.interceptors.response.use(
    response => {
        store.dispatch('loading/setLoadingSpin', false)
        const { status, data } = response;
        if (response instanceof Blob) {
            return response;
        }
        if (status !== 200) {
            return false;
        } else {
            return data
        }
    },
    error => {
        store.dispatch('loading/setLoadingSpin', false)
        let res = error.response;
        console.log(error.response);
        return Promise.reject(error.response.data);
    }
);

export default service;